import $ from 'jquery'

class HeaderGutenberg {
  // desktop
  private readonly MENU_ITEM_WITH_SUBMENU: string = '.menu-item-with-submenu'
  private readonly SUBMENU_CLASS_PREFIX: string = '.submenu-'
  private readonly SEARCH_ICON: string = '.article-search-icon'
  private readonly SEARCH_FORM: string = '.article-search-form'
  private readonly CLOSE_ICON: string = '.article-search-form-close-icon'
  private readonly ICON_BUTTONS_RIGHT_UL: string = '.icon-buttons'

  // mobile
  private readonly SEARCH_ICON_MOBILE: string = '.article-search-icon-mobile'
  private readonly SEARCH_FORM_MOBILE: string = '.article-search-form-mobile'
  private readonly SEARCH_CLOSE_ICON_MOBILE: string =
    '.article-search-form-close-icon-mobile'
  private readonly HAMBURGER_MOBILE: string = '.hamburger-mobile'
  private readonly CLOSE_ICON_MOBILE: string = '.close-icon-mobile'
  private readonly BACK_BUTTON_MOBILE: string = '.mobile-submenu-back-button'
  private readonly MAIN_PAGE_CONTENT: string = '#content'
  private readonly FOOTER: string = 'footer'
  private readonly MAIN_NAV_LINKS_SECTION_MOBILE: string = '.nav-links'
  private readonly NAV_CONTENT_MOBILE: string = '.nav-content-mobile'
  private readonly SUBMENU_CLASS_PREFIX_MOBILE: string = '.submenu-mobile-'
  private readonly MENU_ITEM_WITH_SUBMENU_MOBILE: string =
    '.mobile-menu-item-with-submenu'
  private readonly SUBMENU_CLASS_MOBILE: string = '.custom-sub-menu-mobile'
  private readonly BOTTTOM_BUTTON_CONTAINER: string =
    '.bottom-buttons-container'
  // private readonly WP_ADMIN_BAR: string = '#wpadminbar'
  // private readonly NAV_TOP_ROW_MOBILE: string = '.nav-top-row-mobile'

  private readonly SLIDE_DURATION: number = 400

  private getCustomMenuType($menuItem: JQuery): string {
  const classAttr = $menuItem.attr('class')
  if (!classAttr) return ''

  const classList = classAttr.split(/\s+/)
  let customType = ''

  classList.forEach((className: string) => {
    if (className.startsWith('submenu-type-')) {
      customType = className.replace('submenu-type-', '')
    }
  })
  return customType
}

  private setupSubmenuHover() {
    const menuItemsWithSubmenu = $(this.MENU_ITEM_WITH_SUBMENU)

    menuItemsWithSubmenu.each((_: number, menuItem: HTMLElement) => {
      const $menuItem = $(menuItem)
      const menuCustomType = this.getCustomMenuType($menuItem)
      const submenuSelector = this.SUBMENU_CLASS_PREFIX + menuCustomType
      const $submenu = $(submenuSelector)

      if ($submenu.length) {
        // Show submenu on hover of main menu item
        $menuItem.on('mouseenter', () => {
          $submenu.css('display', 'block') // Display submenu without animation
        })

        // Keep submenu open when hovering over the submenu
        $submenu.on('mouseenter', () => {
          $submenu.css('display', 'block') // Keep submenu visible
        })

        // Hide submenu when mouse leaves both the main item and submenu
        $menuItem.on('mouseleave', () => {
          if (!$submenu.is(':hover')) {
            $submenu.css('display', 'none') // Hide submenu without animation
          }
        })

        $submenu.on('mouseleave', () => {
          $submenu.css('display', 'none') // Hide submenu without animation
        })
      }
    })
  }

  private setupMobileMenuActions() {
    const $hamburger = $(this.HAMBURGER_MOBILE)
    const $pageMainContent = $(this.MAIN_PAGE_CONTENT)
    const $footer = $(this.FOOTER)
    const $closeIcon = $(this.CLOSE_ICON_MOBILE)
    const $backButtons = $(this.BACK_BUTTON_MOBILE)
    const $mainNavigationLinksSection = $(this.MAIN_NAV_LINKS_SECTION_MOBILE)
    const $navContent = $(this.NAV_CONTENT_MOBILE)
    const $menuItemsWithSubmenu = $(this.MENU_ITEM_WITH_SUBMENU_MOBILE)
    const $submenus = $(this.SUBMENU_CLASS_MOBILE)
    const $bottomButtonsContainer = $(this.BOTTTOM_BUTTON_CONTAINER)

    // Event listener for opening the mobile menu
    $hamburger.on('click', () => {
      $closeIcon
        .removeClass('hidden-header-helper')
        .addClass('visible-header-helper')
      $hamburger
        .removeClass('visible-header-helper')
        .addClass('hidden-header-helper')
      $pageMainContent
        .removeClass('visible-header-helper')
        .addClass('hidden-header-helper')
      $footer
        .removeClass('visible-header-helper')
        .addClass('hidden-header-helper')
      $mainNavigationLinksSection
        .removeClass('hidden-header-helper')
        .addClass('visible-header-helper')
      $navContent
        .removeClass('hidden-header-helper')
        .addClass('flex-header-helper')
    })

    // Event listener for closing the mobile menu
    $closeIcon.on('click', () => {
      $closeIcon
        .removeClass('visible-header-helper')
        .addClass('hidden-header-helper')
      $hamburger
        .removeClass('hidden-header-helper')
        .addClass('visible-header-helper')
      $pageMainContent
        .removeClass('hidden-header-helper')
        .addClass('visible-header-helper')
      $footer
        .removeClass('hidden-header-helper')
        .addClass('visible-header-helper')
      $mainNavigationLinksSection
        .removeClass('visible-header-helper')
        .addClass('hidden-header-helper')
      $navContent
        .removeClass('flex-header-helper')
        .addClass('hidden-header-helper')
      $submenus
        .removeClass('visible-header-helper')
        .addClass('hidden-header-helper')
    })

    // Setting up submenu actions for mobile
    $menuItemsWithSubmenu.each((_, menuItem) => {
      const $menuItem = $(menuItem)
      const menuCustomType = this.getCustomMenuType($menuItem)
      const submenuSelector = this.SUBMENU_CLASS_PREFIX_MOBILE + menuCustomType
      const $submenu = $(submenuSelector)

      if ($submenu.length) {
        $menuItem.on('click', () => {
          $submenu
            .removeClass('hidden-header-helper')
            .addClass('visible-header-helper')
          $mainNavigationLinksSection
            .removeClass('visible-header-helper')
            .addClass('hidden-header-helper')
          $bottomButtonsContainer
            .removeClass('flex-header-helper')
            .addClass('hidden-header-helper')
        })
      }
    })

    // Event listener for back button in submenus
    $backButtons.on('click', () => {
      $submenus
        .removeClass('visible-header-helper')
        .addClass('hidden-header-helper')
      $mainNavigationLinksSection
        .removeClass('hidden-header-helper')
        .addClass('visible-header-helper')
      $bottomButtonsContainer
        .removeClass('hidden-header-helper')
        .addClass('flex-header-helper')
    })
  }

  private setupSearchActions() {
    const $searchIcon = $(this.SEARCH_ICON)
    const $searchForm = $(this.SEARCH_FORM)
    const $closeIcon = $(this.CLOSE_ICON)

    const $searchIconMobile = $(this.SEARCH_ICON_MOBILE)
    const $searchFormMobile = $(this.SEARCH_FORM_MOBILE)
    const $searchCloseIconMobile = $(this.SEARCH_CLOSE_ICON_MOBILE)
    const $iconButtons = $(this.ICON_BUTTONS_RIGHT_UL)

    // Click event to open search form and hide search icon
    $searchIcon.on('click', () => {
      $searchIcon.css('display', 'none') // Hide search icon
      $searchForm.css('display', 'flex') // Make search form visible
    })

    // Click event to close search form and show search icon
    $closeIcon.on('click', () => {
      $searchForm.animate({ width: '0' }, this.SLIDE_DURATION, () => {
        $searchForm.css('display', 'none') // Hide form after collapsing
        $searchIcon.css('display', 'flex') // Show search icon
        $searchForm.css({ width: 'initial' })
      })
    })

    $searchIconMobile.on('click', () => {
      $searchFormMobile.css('display', 'flex') // Make search form visible
      $iconButtons.css('display', 'none')
    })

    // Click event to close search form and show search icon
    $searchCloseIconMobile.on('click', () => {
      $searchFormMobile.animate({ width: '0' }, this.SLIDE_DURATION, () => {
        $searchFormMobile.css('display', 'none') // Hide form after collapsing
        $searchIconMobile.css('display', 'flex') // Show search icon
        $searchFormMobile.css({ width: 'initial' })
        $iconButtons.css('display', 'flex')
      })
    })
  }

  private init = () => {
    // console.log('   DOM loaded. Initializing custom submenu behavior.')
    this.setupSubmenuHover()
    this.setupSearchActions()
    this.setupMobileMenuActions()
  }

  constructor() {
    document.addEventListener('DOMContentLoaded', () => {
      this.init()
    })
    // console.log('HeaderGutenberg() - Waiting for DOM to load')
  }
}

new HeaderGutenberg()
